module.exports = __webpack_public_path__ + "static/media/travel_inconveniences.9f811e8f.svg";